(function () {
  'use strict';

  angular
    .module('web2print.landing')
    .directive('deliveryOptionSelector', deliveryOptionSelector);

  /* @ngInject */
  function deliveryOptionSelector () {
    const directive = {
      restrict: 'E',
      templateUrl: 'components/landing/delivery-option-selector/delivery-option-selector.directive.html',
      scope: {
        additionalServices: '='
      },
      link: linkFunc,
      controller: DeliveryOptionSelectorController,
      controllerAs: 'deliveryOptionSelector',
      bindToController: true
    };

    return directive;

    function linkFunc (scope, el, attr, ctrl) {
      scope.$watch('deliveryOptionSelector.additionalServices', scope.deliveryOptionSelector.activate);

    }
  }

  DeliveryOptionSelectorController.$inject = ['$filter'];

  /* @ngInject */
  function DeliveryOptionSelectorController ($filter) {
    const vm = this;

    vm.activate = activate;
    vm.selectOption = selectOption;

    // activate();

    ///////////////////////////

    function activate (newVal) {
      vm.deliveryOptions = $filter('filter')(vm.additionalServices, {type: 'deliveryOption'});

      const selectedOption = _.find(vm.deliveryOptions, {selected: true});
      if (vm.deliveryOptions && vm.deliveryOptions.length > 0 && !selectedOption) {
        vm.deliveryOptions[0].selected = true;
      }
    }

    function selectOption (option) {
      _.map(vm.deliveryOptions, function (o) {
        o.selected = false;
      });

      option.selected = true;
    }
  }
})();
